import { EstadoPagoChoiceEnum, ROUTER_PATHS, gridSizeMdLg12, gridSizeMdLg4, gridSizeMdLg6, gridSizeMdLg8, texto } from "@/shared";
import { CustomTextArea, LoaderComponent, SingleButton, SingleTableBoxScene, TabTextLabel } from "@/shared/components/ui";
import { CardMedia, Grid, Typography } from "@mui/material";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useForm } from "react-hook-form";
import { useUiStore } from "@/store/ui";
import { DescripcionPagoInstall } from "@/shared/interfaces";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useGetPreagendamiento, useUpdatePreagendamiento } from "@/shared/actions/erp";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup';

//CONTABILIDAD

interface IVocuherAccion {
  motivo: string;
}

const newSchemaVoucher = yup.object({
  motivo: yup
    .string()
    .required('Campo Obligatorio'),
});

export default function VoucherAccionPage() {

  const { id_preagendamiento } = useParams();

  const navigate = useNavigate();
  //STATE
  const [modalRechazo, setModalRechazo] = useState<boolean>(false);

  //const [modalAceptar, setModalAceptar] = useState<boolean>(false)

  const setConfirmDialog = useUiStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);

  //FETCH
  const { isLoading: isLoadingAgenda, data: agendaRes } = useGetPreagendamiento(id_preagendamiento!);
  const updateAgenda = useUpdatePreagendamiento()

  const form = useForm<IVocuherAccion>({
    resolver: yupResolver(newSchemaVoucher)
  });

  const {
    handleSubmit,
  } = form;

  useEffect(() => {
    if (!isLoadingAgenda) {
    }
    return () => { }
  }, [agendaRes]);


  if (isLoadingAgenda) return <LoaderComponent />

  return (
    <>
      <SingleTableBoxScene
        title={texto.revision_comprobante}
        visibleReport={false}
        enableBackBtn={true}
        backPageUrl={ROUTER_PATHS.contabilidad.revisionVoucherNav}
      >
        <Grid container spacing={3} >
          <Grid item {...gridSizeMdLg4} >
            <Grid container spacing={3} direction={'row'}>
              <Grid item {...gridSizeMdLg12}>
                <TabTextLabel text={'Número de Comprobante'} mt={0} pb={0} pl={0} pt={0} />
              </Grid>
              <Grid item {...gridSizeMdLg12}>
                <Typography variant="h5">{agendaRes?.data.numero_comprobante}</Typography>
              </Grid>

              <Grid item {...gridSizeMdLg12}>
                <TabTextLabel text={'Valor por Pagar'} mt={0} pb={0} pl={0} pt={0} />
              </Grid>
              <Grid item {...gridSizeMdLg12}>
                <Typography variant="h5">${agendaRes?.data.preventa_data.valor_instalacion}</Typography>
              </Grid>

              <Grid item {...gridSizeMdLg12}>
                <TabTextLabel text={'cliente nombre'} mt={0} pb={0} pl={0} pt={0} />
              </Grid>

              <Grid item {...gridSizeMdLg12}>
                <Typography variant="h5">{agendaRes?.data.prospecto_data.razon_social}</Typography>
              </Grid>

              <Grid item {...gridSizeMdLg12}>
                <TabTextLabel text={'Número de Referencia'} mt={0} pb={0} pl={0} pt={0} />
              </Grid>
              <Grid item {...gridSizeMdLg12}>
                <Typography variant="h5">{agendaRes?.data.numero_referencia || 'undefined'}</Typography>
              </Grid>

              <Grid item {...gridSizeMdLg12}>
                <TabTextLabel text={'Número de Contrato'} mt={0} pb={0} pl={0} pt={0} />
              </Grid>
              <Grid item {...gridSizeMdLg12}>
                <Typography variant="h5">{agendaRes?.data.contrato_data.numero_referencia}</Typography>
              </Grid>

              <Grid item {...gridSizeMdLg6}>
                <SingleButton
                  startIcon={<HighlightOffIcon />}
                  variant="text"
                  width="100%"
                  label="Rechazar"
                  onClick={() => setModalRechazo(true)}
                />
              </Grid>

              <Grid item {...gridSizeMdLg6}>
                <SingleButton
                  startIcon={<CheckCircleIcon />}
                  variant="contained"
                  color={'success'}
                  width="100%"
                  label="Aceptar"
                  onClick={() => {
                    //setModalAceptar(true);
                    setConfirmDialog({
                      isOpen: true,
                      subtitle: '¿Está seguro, una vez aceptado el comprobante PYL puede realizar agendandamiento',
                      title: 'Confirmar Aceptación',
                      onConfirm: async () => {
                        const resp = await updateAgenda.mutateAsync({
                          data: {
                            pasa_revision: true,
                            descripcion_pago: DescripcionPagoInstall.PAGADO,
                            estado_pago: EstadoPagoChoiceEnum.PAGADO
                          } as any, id: agendaRes?.data.id_preagendamiento!
                        });

                        setConfirmDialogIsOpen(false);
                        if (resp.code == 200) {
                          navigate(ROUTER_PATHS.contabilidad.revisionVoucherNav);
                          return;
                        }
                      },
                      onClose() {
                        setConfirmDialogIsOpen(false);
                      },
                    });
                  }}
                />

              </Grid>
            </Grid>
          </Grid>
          <Grid item {...gridSizeMdLg8}>
            <Grid container spacing={3}>

              <Grid item {...gridSizeMdLg12}>
                <TabTextLabel text={'NÚMERO DE COMPROBANTE'} mt={0} pb={0} pl={0} pt={0} />
              </Grid>
              <Grid item {...gridSizeMdLg12}>
                {/* <Img src={agendaRes?.data.foto_comprobante} alt="asd" /> */}
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <CardMedia
                    component="img"
                    alt="Comprobante-pago"
                    image={agendaRes?.data.url_foto_comprobante}
                  />
                </div>
              </Grid>
            </Grid>


          </Grid>
        </Grid>

      </SingleTableBoxScene>

      <ScrollableDialogProps
        open={modalRechazo}
        title="Confirmar Rechazo"

        confirmVariantBtn='contained'
        onClose={() => setModalRechazo(false)}
        // actions
        onConfirm={handleSubmit(async () => {
          const resp = await updateAgenda.mutateAsync({
            data: {
              pasa_revision: false,
              descripcion_pago: DescripcionPagoInstall.PENDIENTE,
              estado_pago: EstadoPagoChoiceEnum.ANULADO
            } as any, id: agendaRes?.data.id_preagendamiento!
          });

          if (resp.code == 200) {
            navigate(ROUTER_PATHS.contabilidad.revisionVoucherNav);
            return;
          }
        })}
        // content
        minWidth="40%"
        contentNode={

          <Grid container spacing={2}>
            <CustomTextArea
              rows={4}
              label="Motivo de Rechazo"
              name="motivo"
              control={form.control}
              defaultValue={
                form.getValues('motivo') || ''
              }
              error={form.formState.errors.motivo}
              helperText={
                form.formState.errors.motivo?.message
              }
              required={false}
            />
          </Grid>

        }
      />




    </>
  )

}